<div class="breadcrumb">
  <div class="container">
    <a routerLink="/">Home</a> > <a routerLink="/grupo-lista">{{ 'Lista de grupos' | translate}}</a> > {{ 'Detalhe do Grupo' | translate}}
  </div>
</div>

<main class="container">
  
    <h1>{{ 'Detalhe do Grupo' | translate}}: {{ nomeGrupo }}</h1>
    <div class="flex space-between filtros">
        <div class="filtros"></div>
        <div class="add_group_button filtro">
            <label>&nbsp;</label>
            <button class="red_button" (click)="back()">{{ 'Voltar' | translate}}</button>
        </div>
    </div>    

    <div class="flex form filtros">
      <div class="form-group filtro">
         <label for="groupName">{{ 'Nome do Grupo' | translate}}</label>
         <input type="text" id="groupName" class="form-control" [(ngModel)]="nomeGrupo">
      </div>
      <div class="form-group filtro">
        <label>&nbsp;</label>
        <button class="red_button" (click)="gravarGrupo()">{{ 'Salvar' | translate}}</button>
      </div>
      <div class="form-group filtro" *ngIf="!isInclusao">
        <label>&nbsp;</label>
        <button *ngIf="dadosGrupo.isActive !== false" class="red_button" (click)="toggleActiveGroup(false)">{{ 'Desativar Grupo' | translate}}</button>
        <button *ngIf="dadosGrupo.isActive === false" class="dark_button" (click)="toggleActiveGroup(true)">{{ 'Reativar Grupo' | translate}}</button>
      </div>
   </div>


  <div class="flex space-between filtros">
    <div class="add_group_button filtro" *ngIf="!isInclusao">
        <label>&nbsp;</label>
        <button (click)="showAddGroup = !showAddGroup" class="red_button" *ngIf="!showAddGroup">{{ 'Adicionar País/Região' | translate}}</button>
        <button (click)="showAddGroup = !showAddGroup" class="red_button" *ngIf="showAddGroup">{{ 'Fechar' | translate}}</button>
    </div>
  </div>

  <div class="add_group" *ngIf="showAddGroup">
    <h2 i18n>{{ 'Adicionar Nova Associação de País/Região' | translate}}:</h2>
    <div class="flex form filtros">
        <div class="form-group filtro">
            <label for="newCountry">{{ 'País' | translate}}:</label>
            <select id="newCountry" class="form-control" [(ngModel)]="newAssociation.countryId" (change)="carregaFiltroRegioes($event)">
                <option value="" disabled selected>{{ 'Selecione um País' | translate}}</option>
                <option *ngFor="let pais of listaPaises" [value]="pais.id">{{pais.name}}</option>
            </select>
        </div>
        <div class="form-group filtro">
            <label for="newRegion">{{ 'Região' | translate}}:</label>
            <select id="newRegion" class="form-control" [(ngModel)]="newAssociation.regionId">
                <option value="" selected>{{ 'Todas' | translate}}</option>
                <option *ngFor="let regiao of listaRegiao" [value]="regiao.id">{{regiao.name}}</option>
            </select>
        </div>
        <div class="form-group filtro">
            <label for="newWeight">{{ 'Volume' | translate}} %:</label>
            <input type="number" id="newWeight" class="form-control" [(ngModel)]="newAssociation.weight" appNumeroDe1a100>
        </div>
        <div class="form-group filtro">
            <label>&nbsp;</label>
            <button class="red_button" (click)="adicionarAssociacao()">{{ 'Adicionar' | translate}}</button>
        </div>
    </div>
      <div class="table-container">
          <table border="0" cellpadding="0" cellspacing="0">
        <thead>
            <tr>
                <th>{{ 'País' | translate}}</th>
                <th>{{ 'Região' | translate}}</th>
                <th width="200px">{{ 'Volume' | translate}} %</th>
                <th i18n>{{ 'Qtd usuários' | translate}}</th>
                <th class="text-center">{{ 'Ações' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let gcr of groupCountryRegions">
                <td>{{gcr.countryName}}</td>
                <td>{{gcr.regionName}}</td>
                <td>
                    <input type="number" class="form-control" [(ngModel)]="gcr.weight" appNumeroDe1a100>
                </td>
                <td><span style="align-content: center !important;">{{gcr.userMembers}}</span></td>
                <td class="text-center">
                    <a (click)="removeGroupCountryRegion(gcr)" class="dark_button" title="{{ 'Remover' | translate}}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                    </a>
                    <a (click)="adicionarUsuarioaGrupo(gcr.idGrupoRegion); $event.stopPropagation();" class="light_button" title="{{ 'Adicionar usuario' | translate}}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/><path d="M14 3v5h5M16 13H8M16 17H8M10 9H8"/></svg>
                    </a>
                </td>
            </tr>
        </tbody>
      </table>
    </div>
      <div class="button-group">
        <button class="red_button padding" (click)="saveAssociations()">{{ 'Salvar' | translate}}</button>
      </div>
    </div>


  <div class="flex space-between filtros">
    <div class="add_group_button filtro" *ngIf="!isInclusao">
        <label>&nbsp;</label>
        <button (click)="openModalResponsavel()" class="red_button">{{ 'Associar Responsável ao Grupo' | translate}}</button>
    </div>
  </div>
</main>

<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isModal1Open">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title" i18n>{{ 'Associar usuário ao grupo' | translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal1()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group filtro">
            <label for="userSelect">{{ 'Selecione o usuário' | translate}}:</label>
            <select id="userSelect" class="form-control" [(ngModel)]="selectedUserId">
                <option value="" disabled selected>{{ 'Selecione um usuário' | translate}}</option>
                <option *ngFor="let user of availableUsers" [value]="user.id">{{user.email}}</option>
            </select>
        </div>
        &nbsp;
        &nbsp;
        <div class="form-group">
            <div class="table-container">
               <table border="0" cellpadding="0" cellspacing="0">
                  <thead>
                      <tr>
                          <th i18n>#</th>
                          <th i18n>{{ 'Email' | translate}}</th>
                          <th i18n>{{ 'Ações' | translate}}</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor='let item of listaShowItensUsers | paginate: { itemsPerPage: pageSize, currentPage: currentPage, totalItems: totalItems }; let i = index'>
                          <td>
                              {{ (currentPage - 1) * 15 + i + 1 }}
                          </td>
                          <td>
                              {{item.email}}
                          </td>
                          <td>
                              <a (click)="removeOfGrupo(item)" class="dark_button">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                              </a>
                          </td>
                      </tr>
                  </tbody>
                  </table>
            </div>
        </div>
      </div>
      <div class="modal-footer">
            <button class="red_button padding" (click)="associateUser()">{{ 'Associar' | translate}}</button>
            <button class="red_button padding" (click)="closeModal1()">{{ 'Fechar' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal modalResponsavel" tabindex="-1" role="dialog" *ngIf="isModalResponsavelOpen">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header flex space-between">
                <h5 class="modal-title">{{ 'Associar Responsável ao Grupo' | translate}}</h5>
                <button type="button" class="close" aria-label="Close" (click)="closeModalResponsavel()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="flex form filtros">
                    <div class="form-group filtro">
                        <select id="userSelectResp" class="form-control" [(ngModel)]="newResponsible.idUser">
                            <option value="" disabled selected>{{ 'Selecione um usuário' | translate}}</option>
                            <option *ngFor="let user of usersList" [value]="user.id">{{user.email}}</option>
                        </select>
                    </div>
                    <div class="form-group filtro">
                        <button class="red_button" (click)="addUserResponsible()">{{ 'Adicionar Responsável' | translate}}</button>
                    </div>
                </div>
                <div class="form-group" *ngIf="!isInclusao && !isAdminGrupoUser">
                    <div class="table-container">
                        <table border="0" cellpadding="0" cellspacing="0">
                            <thead>
                                <tr>
                                    <th i18n>#</th>
                                    <th i18n>{{ 'Email' | translate}}</th>
                                    <th i18n>{{ 'Ações' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let item of groupUserResponsible | paginate: { itemsPerPage: pageSize, currentPage: currentPage, totalItems: totalItems }; let i = index'>
                                    <td>{{ (currentPage - 1) * 15 + i + 1 }}</td>
                                    <td>{{item.userEmail}}</td>
                                    <td>
                                        <a (click)="removeUserResponsible(item)" class="dark_button" *ngIf="!isInclusao && !isAdminGrupoUser">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="red_button padding" (click)="closeModalResponsavel()">{{ 'Fechar' | translate}}</button>
            </div>
        </div>
    </div>
</div>